import React, { PureComponent } from 'react';

import Grid from 'components/grid/Grid';
import { Loader } from 'components/loader';
import { ClassService } from 'modules/classManager';
import PropTypes from 'prop-types';

import ClassUsersHeader from './ClassUsersHeader';
import ClassUsersList from './ClassUsersList';

import './ClassUsers.scss';

class ClassUsers extends PureComponent {
  // #region set up
  static propTypes = {
    backHandler: PropTypes.func,
    classId: PropTypes.string
  };

  state = {
    filters: {
      classId: this.props.classId,
      searchText: '',
      userType: ''
    },
    items: [],
    loading: true,
    pagination: { page: 0 }
  };

  classUsersListRef = React.createRef();

  constructor(props) {
    super(props);

    this.changeClass = this.changeClass.bind(this);
    this.changeUserType = this.changeUserType.bind(this);
    this.fetchItems = this.fetchItems.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateItems = this.updateItems.bind(this);
    this.updateCheckItems = this.updateCheckItems.bind(this);
  }

  async componentDidMount() {
    this.updateItems();
  }
  // #endregion

  // #region actions
  async fetchItems(dataTableParams = {}) {
    this.setState({ loading: true });

    const { filters } = this.state;
    const params = Object.assign({}, dataTableParams, { filters });

    const response = await ClassService.searchUser(params);
    const { content: items, ...pagination } = response;

    this.setState({ items, pagination, loading: false });
  }

  async changeClass(selectedClass) {
    this.setState({ loading: true });

    const { filters } = this.state;
    const dataTableRef = this.classUsersListRef.current.dataTableRef;
    const params = Object.assign({}, dataTableRef.current.data, {
      filters,
      selectedClass
    });

    const success = await ClassService.changeClass(params);

    if (success) {
      const { backHandler } = this.props;

      backHandler && backHandler();
    } else {
      this.setState({ loading: false });
    }
  }
  // #endregion

  // #region handlers
  handleChange(searchText) {
    const { filters, pagination } = this.state;
    const newFilters = { ...filters, searchText };
    const newPagination = { ...pagination, page: 0 };

    this.setState({ filters: newFilters, pagination: newPagination }, () => {
      this.updateItems(newPagination.page);
    });
  }

  changeUserType(userType) {
    const { filters, pagination } = this.state;
    const newFilters = { ...filters, userType: userType ? userType : '' };
    const newPagination = { ...pagination, page: 0 };

    this.setState({ filters: newFilters, pagination: newPagination }, () => {
      this.updateItems(newPagination.page);
    });
  }

  updateItems(page) {
    if (this.classUsersListRef && this.classUsersListRef.current) {
      this.classUsersListRef.current.updateItems(page);
    }
  }

  updateCheckItems({ newItems }) {
    this.setState({ items: newItems });
  }
  // #endregion

  // #region render
  render() {
    const { filters, items, loading, pagination } = this.state;
    const { classId } = this.props;

    return (
      <Grid block nopadding className="class__users" data-test="users-grid">
        <ClassUsersHeader
          key="class-users-header"
          changeClass={this.changeClass}
          changeUserType={this.changeUserType}
          classId={classId}
          filters={filters}
          handleChange={this.handleChange}
          pagination={pagination}
        />

        <ClassUsersList
          key="class-users-list"
          items={items}
          fetchItems={this.fetchItems}
          loading={loading}
          pagination={pagination}
          ref={this.classUsersListRef}
          updateCheckItems={this.updateCheckItems}
        />

        {loading && <Loader key="loader" mask />}
      </Grid>
    );
  }
  // #endregion
}

export default ClassUsers;
